module.exports = __webpack_public_path__ + "assets/images/nav-reports.7da485f55e71299e65e39007a8aa0980.svg";